import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';

import { BlockHeaderContent } from '@/features/utils/BlockHeaderContentDC';
import { BlockWrapper } from '@/features/utils/BlockWrapperDC';

import { EmptyOpenPositions } from './EmptyOpenPositions';
import { OpenPositionsList, OpenPositionsListProps } from './OpenPositionsList';

export type OpenPositionsProps = {
  title: string;
  positions: OpenPositionsListProps['items'];
};

export function OpenPositions({ title, positions }: OpenPositionsProps) {
  return (
    <BlockWrapper data-tracker-section={SECTION_NAMES.OPEN_POSITIONS_LIST}>
      <div className='w-full'>
        <BlockHeaderContent title={title}>
          {positions.length === 0 && <EmptyOpenPositions />}
          {positions.length > 0 && <OpenPositionsList items={positions} />}
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
